import script from "./TumorBoardCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TumorBoardCard.vue?vue&type=script&setup=true&lang=js"

import "./TumorBoardCard.vue?vue&type=style&index=0&id=22aedcd7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22aedcd7"]])

export default __exports__